import React, { useState } from 'react';
import { Eye } from 'lucide-react';

const key = (uid) => `cmx:ns-reveal:${uid || 'anon'}`;

/** Dims everything below the hero until the first step is done; one click anywhere reveals the full dashboard for this session.
    Opacity only (no colour filter) — filters repaint the whole region on every scroll frame on phones. */
export default function FocusDim({ active, uid, hint, children }) {
  const [revealed, setRevealed] = useState(() => { try { return sessionStorage.getItem(key(uid)) === '1'; } catch (e) { return false; } });
  const dim = active && !revealed;
  const reveal = () => { setRevealed(true); try { sessionStorage.setItem(key(uid), '1'); } catch (e) { /* private mode */ } };
  return (
    <div className="relative" data-testid="ns-focus-region" data-dimmed={dim}>
      <div className={`space-y-4 md:space-y-6 transition-opacity duration-500 ease-out ${dim ? 'opacity-30 pointer-events-none select-none' : 'opacity-100'}`} aria-hidden={dim}>
        {children}
      </div>
      {dim && (
        <div role="button" tabIndex={0} onClick={reveal} onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && reveal()} className="absolute inset-0 z-10 cursor-pointer group" aria-label="Show my full dashboard" data-testid="ns-dim-overlay">
          <div className="sticky top-24 flex justify-center pt-8 px-4">
            <button type="button" onClick={reveal} className="inline-flex items-center gap-2 rounded-full bg-slate-900/90 text-white text-xs font-semibold px-4 py-2.5 shadow-xl text-center group-hover:bg-slate-900 transition" data-testid="ns-dim-reveal-btn">
              <Eye size={14} className="text-amber-400 shrink-0" /> {hint || 'Finish step 1 first — or tap anywhere to see your full dashboard'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
